import Item from '../Item';
import emitter from '../../emitter';
import { PICKUP_ITEM } from '../../settings/events';
import geometry from '../util/geometry';

export default class MountingRail extends Item {
  constructor(args) {
    super(args);

    this.onPickup = this.onPickup.bind(this);
    emitter.on(PICKUP_ITEM, this.onPickup);
    this.disableInteraction = true;
    this.cursor = 'default';
  }

  onPickup(item) {
    this.alpha = geometry.collides(this.item, item.item, {
      right: 50,
      left: 50,
    })
      ? 0
      : 1;
  }

  destroy(args) {
    emitter.off(PICKUP_ITEM, this.onPickup);
    super.destroy(args);
  }
}
